import { createFileRoute, Navigate } from "@tanstack/react-router";
import { useAuth } from "@clerk/clerk-react";
import { useQuery } from "@tanstack/react-query";
import { organizationsQueryOptions } from "../../api/queries";
import { OnboardingScreen } from "../../components/dashboard/OnboardingScreen";
import { createOrgSlug } from "../../lib/slug";

export const Route = createFileRoute("/organization/")({
  component: OrganizationIndex,
});

function OrganizationIndex() {
  const { getToken } = useAuth();
  const { data, isLoading } = useQuery(organizationsQueryOptions(getToken));
  const organizations = data?.organizations ?? [];

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-gray-200 border-t-primary" />
      </div>
    );
  }

  if (organizations.length === 0) {
    return <OnboardingScreen />;
  }

  const firstOrg = organizations[0]!;
  const slug = createOrgSlug(firstOrg.organizationId, firstOrg.name);

  return (
    <Navigate
      to="/organization/$slug/overview"
      params={{ slug }}
      replace
    />
  );
}
